import { Icon, TableCellTypography } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { TableLabelTypeProps as Props } from './types';

export const TableLabelType = memo(({ className, isCompany }: Props) => {
  const title = useMemo(() => {
    return isCompany ? 'Company' : 'People';
  }, [isCompany]);

  const color = useMemo(() => {
    return isCompany ? 'primary.500' : 'success.600';
  }, [isCompany]);

  return (
    <Styled.Wrapper
      className={classnames('TableLabelType', className)}
      sx={SX.root}
    >
      <Icon
        name={isCompany ? 'business' : 'people-outline'}
        size={18}
        color={color}
      />

      <TableCellTypography item={title} color={color} />
    </Styled.Wrapper>
  );
});

TableLabelType.displayName = 'TableLabelType';
